import { useEffect } from 'react';
import { useSnackbar } from 'notistack';

export const useNetworkStatus = () => {
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const handleOnline = () => {
      enqueueSnackbar('Conectado a internet', {
        variant: 'success',
        autoHideDuration: 3000,
      });
    };

    const handleOffline = () => {
      enqueueSnackbar('Sin conexión a internet', {
        variant: 'error',
        persist: true,
      });
    };

    if (!navigator.onLine) {
      handleOffline();
    }

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [enqueueSnackbar]);
};
